/**
 * Ce que les écrans de la candidature lisent du compte : le candidat, et qui pose les questions
 * d'une étape (son champion, et le titre de l'étape que l'en-tête dit pendant ce temps).
 */
import { type ChampionName } from "../../../../../../design-system/atoms/Avatar/ChampionAvatar"
import { selectAccount } from "../../../../view-models/shared/displayedStudent"
import { type ApiTutorCandidate } from "../../../../adapters/tutor/Application/tutorApplicationAdapter"
import { type UITutorApplicationAsker } from "../../../types/tutorCandidature"

/** Le compte du candidat (`selectAccount`), sous la forme que la candidature lit. */
export function selectCandidate(state: unknown): ApiTutorCandidate | null {
    return selectAccount(state as Parameters<typeof selectAccount>[0]) as ApiTutorCandidate | null
}

export function applicationAsker(
    user: ApiTutorCandidate | null | undefined,
    stepNum: number,
    champion: ChampionName | null
): UITutorApplicationAsker | undefined {
    if (champion == null) return undefined
    return { champion, stepTitle: user?.application_steps?.[stepNum - 1]?.title ?? "" }
}
